<app-create-dialog-layout
  [title]="'i18n.WorkPackageCreateDialog.Title.new' | translate"
  [disabled]="formDisabled"
  (dialogAction)="onDialogAction($event)">
  <div class="flex flex-col gap-3 p-4">
    @if (isInitialized) {
      @switch (project.data?.projectType) {
        @case ('correttive') {
          <div class="form-field">
            <label>Impianto</label>
            <app-constant-picker
              [placeholder]="'Seleziona impianto'"
              [options]="impiantoOptions"
              [allowClear]="true"
              [control]="correttivaForm.controls.impianto"
              [autoSelectSingleChoice]="false">
            </app-constant-picker>
          </div>

          <div class="form-field">
            <label>Ubicazione</label>
            <app-constant-picker
              [placeholder]="'Seleziona impianto'"
              [options]="ubicazioneOptions"
              [allowClear]="true"
              [control]="correttivaForm.controls.ubicazione"
              [autoSelectSingleChoice]="false">
            </app-constant-picker>
          </div>

          <div class="form-field">
            <label>Descrizione I livello</label>
            <app-constant-picker
              [placeholder]="'Seleziona descrizione I livello'"
              [options]="assetL1Options"
              [allowClear]="true"
              [control]="correttivaForm.controls.assetL1"
              [autoSelectSingleChoice]="false">
            </app-constant-picker>
          </div>

          <div class="form-field">
            <label>Descrizione II livello</label>
            <app-constant-picker
              [placeholder]="'Seleziona descrizione II livello'"
              [options]="assetL2Options"
              [allowClear]="true"
              [control]="correttivaForm.controls.assetL2"
              [autoSelectSingleChoice]="false">
            </app-constant-picker>
          </div>

          <div class="form-field">
            <label>Guasto</label>
            <app-constant-picker
              [placeholder]="'Seleziona guasto'"
              [options]="guastoOptions"
              [allowClear]="true"
              [control]="correttivaForm.controls.guasto"
              [autoSelectSingleChoice]="false">
            </app-constant-picker>
          </div>

          @if (correttivaForm.controls.guasto.value === 'ALTRO' || correttivaForm.controls.guasto.value === 'VARIE') {
            <div class="form-field flex grow">
              <app-smart-input-string
                id="guastoCustom"
                placeholder="i18n.WorkPackageCreateDialog.Placeholder.guastoCustom"
                [control]="correttivaForm.controls.guastoCustom">
              </app-smart-input-string>
            </div>
          }

          <div class="form-field flex grow">
            <label for="description">
              {{ 'i18n.WorkPackageCreateDialog.Label.description' | translate }}
              <span class="details">{{ 'i18n.Common.optional' | translate }}</span>
            </label>

            <app-smart-input-rich-text
              id="description"
              placeholder="i18n.WorkPackageCreateDialog.Placeholder.description"
              [control]="correttivaForm.controls.description">
            </app-smart-input-rich-text>
          </div>

          <!-- <div class="form-field flex grow">
            <label for="workPackageStatusId">
              {{ 'i18n.WorkPackageCreateDialog.Label.status' | translate }}
            </label>
            <app-wp-status-picker
              class="w-full"
              [control]="correttivaForm.controls.workPackageStatus"></app-wp-status-picker>
          </div> -->

          <!-- <div class="form-field flex grow">
            <label for="workPackageTypeId">
              {{ 'i18n.WorkPackageCreateDialog.Label.type' | translate }}
            </label>
            <app-wp-type-picker
              class="w-full"
              [projectOptions]="data.project.workPackageTypes"
              [control]="correttivaForm.controls.workPackageType"></app-wp-type-picker>
          </div> -->

          <div class="form-field flex grow">
            <label for="workPackagePriorityId">
              {{ 'i18n.WorkPackageCreateDialog.Label.priority' | translate }}
            </label>
            <app-wp-priority-picker
              class="w-full"
              [control]="correttivaForm.controls.workPackagePriority"></app-wp-priority-picker>
          </div>

          <!-- <app-wp-assignees
            addPlaceholder="i18n.WorkPackageDetailsPage.Assignees.addAssignee"
            noItemsLabel="i18n.WorkPackageDetailsPage.Assignees.noItems"
            shownLabel="i18n.WorkPackageDetailsPage.Assignees.shown"
            [title]="'i18n.WorkPackageDetailsPage.Assignees.title'"
            [projectId]="project.id"
            [control]="correttivaForm.controls.assignees" /> -->

          <div class="form-field flex grow">
            <label for="group">
              {{ 'i18n.WorkPackageCreateDialog.Label.group' | translate }}
            </label>
            <app-group-picker
              placeholder="i18n.WorkPackageCreateDialog.Placeholder.group"
              [control]="correttivaForm.controls.group"
              [onlyAssignable]="true"></app-group-picker>
          </div>
        }
        @case ('programmate') {
          <div class="form-field flex grow">
            <label for="name">
              {{ 'i18n.WorkPackageCreateDialog.Label.name' | translate }}
            </label>
            <input
              pInputText
              id="name"
              [formControl]="form.controls.name"
              [placeholder]="'i18n.WorkPackageCreateDialog.Placeholder.name' | translate" />
          </div>

          <div class="form-field flex grow">
            <label for="description">
              {{ 'i18n.WorkPackageCreateDialog.Label.description' | translate }}
              <span class="details">{{ 'i18n.Common.optional' | translate }}</span>
            </label>

            <app-smart-input-rich-text
              id="description"
              placeholder="i18n.WorkPackageCreateDialog.Placeholder.description"
              [control]="form.controls.description">
            </app-smart-input-rich-text>
          </div>

          @if ((pagePermissions$ | async)?.allowHierarchy) {
            <div class="form-field flex grow">
              <label for="parent">
                {{ 'i18n.WorkPackageCreateDialog.Label.parent' | translate }}
                <span class="details">{{ 'i18n.Common.optional' | translate }}</span>
              </label>
              <app-work-package-picker
                id="parent"
                placeholder="i18n.WorkPackageCreateDialog.Placeholder.parent"
                [projectId]="project.id"
                [control]="form.controls.parent">
              </app-work-package-picker>
            </div>
          }

          <div class="form-field flex grow">
            <label for="workPackageStatusId">
              {{ 'i18n.WorkPackageCreateDialog.Label.status' | translate }}
            </label>
            <app-wp-status-picker
              class="w-full"
              [control]="form.controls.workPackageStatus"></app-wp-status-picker>
          </div>

          <div class="form-field flex grow">
            <label for="workPackageTypeId">
              {{ 'i18n.WorkPackageCreateDialog.Label.type' | translate }}
            </label>
            <app-wp-type-picker
              class="w-full"
              [projectOptions]="data.project.workPackageTypes"
              [control]="form.controls.workPackageType"></app-wp-type-picker>
          </div>

          <div class="form-field flex grow">
            <label for="workPackagePriorityId">
              {{ 'i18n.WorkPackageCreateDialog.Label.priority' | translate }}
            </label>
            <app-wp-priority-picker
              class="w-full"
              [control]="form.controls.workPackagePriority"></app-wp-priority-picker>
          </div>

          <app-wp-assignees
            addPlaceholder="i18n.WorkPackageDetailsPage.Assignees.addAssignee"
            noItemsLabel="i18n.WorkPackageDetailsPage.Assignees.noItems"
            shownLabel="i18n.WorkPackageDetailsPage.Assignees.shown"
            [title]="'i18n.WorkPackageDetailsPage.Assignees.title'"
            [projectId]="project.id"
            [control]="form.controls.assignees" />

          <app-attachments-manager
            [attachmensUploadHandler]="attachmentsUploadHandler"
            [showCount]="false"></app-attachments-manager>
        }
      }
    }
  </div>
</app-create-dialog-layout>
